import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-card-item',
    templateUrl: './card-item.component.html',
    styleUrls: ['./card-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
    ],
})
export class CardItemComponent {

    @Input() headline = '';

    constructor() {
    }
}
